import { jsxs, jsx } from 'react/jsx-runtime';
import { styled } from 'styled-components';
import { useResourceHighlightDataSafe } from '../../../../../resource-detail/components/context/resourceDataContext.js';
import { ColorLabel } from '../../components/ColorLabel.js';
import { ResourcePreviewFavicon } from '../../components/ResourcePreviewFavicon.js';
import { ResourcePreviewDescription, ResourcePreviewTitle } from '../../components/Typography.js';
import { containerPreviewCompact } from '../cssPreviewContainer.js';
import { cssAspectRatio } from '../sharedCss.js';
import React__default from 'react';
import { cssVar } from '@fabric-app/ui/theme/variables';
import { Flex } from '@fabric-app/ui/components/Flex';
import { cleanUrl } from '@fabric-app/utils/url';
import { TruncatorV2 } from '@fabric-app/ui/components/Truncator/TruncatorV2';
import Divider from '@fabric-app/ui/components/Divider';
import { ResourceGridViewLoadingIndicator } from '../components/ResourceGridViewLoadingIndicator.js';

const ResourcePreviewHighlight = () => {
  const { resource, placeholderName } = useResourceHighlightDataSafe();
  const url = resource.originUrl || resource.data.webpage?.url || null;
  const displayUrl = url ? cleanUrl(url) : null;
  const textRef = React__default.useRef(null);
  return /* @__PURE__ */ jsxs(Wrapper, {
    "data-preview-content-wrapper": "text",
    children: [
      /* @__PURE__ */ jsx(ColorLabel, {
        absPosition: "inside-top-left"
      }),
      /* @__PURE__ */ jsx(ResourceGridViewLoadingIndicator, {
        resource
      }),
      /* @__PURE__ */ jsxs(PageHeader, {
        children: [
          url && /* @__PURE__ */ jsx(ResourcePreviewFavicon, {
            pageUrl: url,
            faviconUrl: resource.data.webpage?.favicon?.url
          }),
          /* @__PURE__ */ jsxs(PageInfo, {
            children: [
              displayUrl && /* @__PURE__ */ jsx(StyledMobileResourcePreviewTitle, {
                children: displayUrl
              }),
              /* @__PURE__ */ jsx(StyledResourcePreviewTitle, {
                children: resource.name || placeholderName
              }),
              displayUrl && /* @__PURE__ */ jsx(StyledResourcePreviewDescription, {
                children: displayUrl
              })
            ]
          })
        ]
      }),
      /* @__PURE__ */ jsx(StyledDivider, {
        borderColor: "secondary"
      }),
      /* @__PURE__ */ jsx(TextContent, {
        ref: textRef,
        children: /* @__PURE__ */ jsx(TruncatorV2, {
          parentRef: textRef,
          children: resource.data.extensionContext?.text
        })
      })
    ]
  });
};
const Wrapper = styled.div.withConfig({
  displayName: "ResourcePreviewHighlight__Wrapper",
  componentId: "sc-f8cb0bd5-0"
})([
  `width:100%;height:100%;display:flex;align-items:center;flex-direction:column;flex-grow:1;gap:0.5rem;overflow:hidden;justify-content:center;padding:0.75rem;border-radius:var(--preview-content-border-radius,1.125rem);position:relative;border:var(--preview-border-width,2px) solid var(--preview-border-color,`,
  `);background:`,
  `;`,
  `;`,
  `{border:none;border-radius:0;}`
], cssVar["color-border-secondary"], cssVar["color-bg-primary"], cssAspectRatio, containerPreviewCompact);
const StyledResourcePreviewDescription = styled(ResourcePreviewDescription).withConfig({
  displayName: "ResourcePreviewHighlight__StyledResourcePreviewDescription",
  componentId: "sc-f8cb0bd5-1"
})([
  ``,
  `{display:none;}`
], containerPreviewCompact);
const StyledResourcePreviewTitle = styled(ResourcePreviewTitle).withConfig({
  displayName: "ResourcePreviewHighlight__StyledResourcePreviewTitle",
  componentId: "sc-f8cb0bd5-2"
})([
  ``,
  `{display:none;}`
], containerPreviewCompact);
const StyledMobileResourcePreviewTitle = styled(ResourcePreviewTitle).withConfig({
  displayName: "ResourcePreviewHighlight__StyledMobileResourcePreviewTitle",
  componentId: "sc-f8cb0bd5-3"
})([
  `display:none;`,
  `{display:block;}`
], containerPreviewCompact);
const StyledDivider = styled(Divider).withConfig({
  displayName: "ResourcePreviewHighlight__StyledDivider",
  componentId: "sc-f8cb0bd5-4"
})([
  ``,
  `{display:none;}`
], containerPreviewCompact);
const PageHeader = styled(Flex).withConfig({
  displayName: "ResourcePreviewHighlight__PageHeader",
  componentId: "sc-f8cb0bd5-5"
})([
  `gap:0.5rem;width:100%;overflow:hidden;flex-shrink:0;`,
  `{flex-direction:column;gap:1rem;}`
], containerPreviewCompact);
const PageInfo = styled.div.withConfig({
  displayName: "ResourcePreviewHighlight__PageInfo",
  componentId: "sc-f8cb0bd5-6"
})([
  `display:flex;flex-direction:column;gap:2px;width:100%;overflow:hidden;`
]);
const TextContent = styled.div.withConfig({
  displayName: "ResourcePreviewHighlight__TextContent",
  componentId: "sc-f8cb0bd5-7"
})([
  `flex-grow:1;font-size:0.8125rem;color:`,
  `;overflow:hidden;line-height:1.25rem;`,
  `{line-height:1rem;font-size:0.75rem;}`
], cssVar["color-text-tertiary"], containerPreviewCompact);

export { ResourcePreviewHighlight };
//# sourceMappingURL=ResourcePreviewHighlight.js.map
